<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Note">
        <div style="padding-top: 12px;">
            <app-notes [(application)]="application" [(applicationId)]="applicationId" [(currentUser)]="currentUser" />
        </div>
    </mat-tab>
    <mat-tab label="Call">
        <div style="padding-top: 12px;">
            <app-call [(application)]="application" [currentUser]="currentUser" />
        </div>
    </mat-tab>
    <mat-tab label="Email">
        <div style="padding-top: 12px;">
            <app-email [(application)]="application" />
        </div>
    </mat-tab>
    <mat-tab label="Timeline" *ngIf="currentUser?._canViewTimeline === true">
        <ng-template matTabContent>
            <div style="padding-top: 12px;">
                <app-timeline [applicationId]="applicationId" />
            </div>
        </ng-template>
    </mat-tab>
</mat-tab-group>